import createCrudVuexModule from "@/store/crud";

export const notificationType = createCrudVuexModule({
  namespaced: true,
  path: "/library/notification-type",
  moduleName: `notification-type`,
});

export const workspaceNotificationType = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/notification-type",
});

export const managementNotificationType = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/notification-type",
});
